import { render, staticRenderFns } from "./BuilderSidebarSearchbar.vue?vue&type=template&id=2c6ea9eb&scoped=true&"
import script from "./BuilderSidebarSearchbar.vue?vue&type=script&lang=js&"
export * from "./BuilderSidebarSearchbar.vue?vue&type=script&lang=js&"
import style0 from "./BuilderSidebarSearchbar.vue?vue&type=style&index=0&id=2c6ea9eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ea9eb",
  null
  
)

export default component.exports